import { createFileRoute } from "@tanstack/react-router";
import { ServiceDetail } from "@/components/site/ServiceDetail";
import airbnbAssetUrl from "@/assets/svc-airbnb.webp";
const airbnbAsset = { url: airbnbAssetUrl };

export const Route = createFileRoute("/services/airbnb")({
  head: () => ({
    meta: [
      { title: "Airbnb & Short-Let Cleaning in Salisbury Plain | IZHUB" },
      { name: "description", content: "Fast, reliable Airbnb and short-let turnover cleaning across Tidworth, Andover and Salisbury. Linen changes, restocking and 5-star-ready presentation." },
      { property: "og:title", content: "Airbnb & Short-Let Cleaning | IZHUB Cleaning Services" },
      { property: "og:description", content: "Consistent short-let turnarounds between guests, with linen changes, restocking and discreet issue reporting." },
      { property: "og:url", content: "https://izhubcleaning.uk/services/airbnb" },
    ],
    links: [{ rel: "canonical", href: "https://izhubcleaning.uk/services/airbnb" }],
  }),
  component: AirbnbPage,
});

function AirbnbPage() {
  return (
    <ServiceDetail
      data={{
        title: "Airbnb & Short-Let Cleaning",
        heroTitle: <>Turnarounds that earn <span className="rainbow-text">5★ reviews</span>.</>,
        intro: "Fast, consistent cleaning between guests for Airbnb hosts and short-let owners across Tidworth, Andover and Salisbury.",
        image: airbnbAsset.url,
        imageAlt: "A perfectly presented short-let property ready for the next guest",
        forWho: "Airbnb hosts, short-let owners, property managers.",
        quoteService: "airbnb",
        includes: [
          "Consistent turnaround windows around check-outs",
          "Fresh linen and towel changes (your linen or ours)",
          "Restocking of essentials on request",
          "Full kitchen and bathroom clean between stays",
          "Discreet issue reporting with photos if needed",
          "Key-safe or hosted access, whatever suits your setup",
        ],
        paragraphs: [
          "Short-let guests notice everything; reviews reflect it. Our Airbnb and short-let service is built around your check-in and check-out times, so the property is guest-ready every single turnover, even on same-day changeovers.",
          "We handle linen and towel changes, restock essentials on request, and flag anything that needs your attention (damage, missing items or maintenance issues) with photos, so you can act before the next guest arrives.",
          "Whether you manage one listing or several across Salisbury Plain, we become a reliable part of your hosting operation. Message us on WhatsApp with your listing details and we'll set up a turnover schedule that runs itself.",
        ],
      }}
    />
  );
}
